import { CheckIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';
import type { ChangeEventHandler } from 'react';

import OptionContainer from './OptionContainer';
import OptionLabel from './OptionLabel';

interface Props {
  name: string;
  value: string;
  onChange: (value: string, checked: boolean) => void;
  isSelected: boolean;
  index?: number;
}

const NumeralOption = ({ name, value, onChange, isSelected, index }: Props) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => onChange(value, e.currentTarget.checked);

  return (
    <OptionContainer className={classNames('hover:bg-[#F3F4F6]', isSelected ? 'rounded-sm bg-[#F3F4F6]' : '')}>
      <input
        name={name}
        id={name}
        type="checkbox"
        className="hidden"
        onChange={handleChange}
        value={value}
        aria-hidden
      />
      <label htmlFor={name} className={classNames('inline-flex flex-row items-center justify-between gap-x-2')}>
        <OptionLabel isSelected={isSelected}>
          {typeof index === 'number' ? `${index + 1}.` : null} {value}
        </OptionLabel>
        {isSelected ? <CheckIcon className="h-4 w-4" /> : null}
      </label>
    </OptionContainer>
  );
};

export default NumeralOption;
